/**
 * This factory must be separated out because the sitemap uses the apollo
 * client without the stateLink and breaks if it has an import chain to
 * LocalState (at a glance, because it's not configured to handle imports
 * from graphql files)
 */

import { withClientState } from 'apollo-link-state'
import LocalState from '../../../shared/local-state'
import makeApolloClient from './index'

export default function makeApolloClientWithStateLink({ ...opts }) {
  const makeStateLink = cache => withClientState({ cache, ...LocalState })
  return makeApolloClient({ ...opts, makeStateLink })
}
